import React from "react";
import { Row, Table } from "antd";
import {
  YMaps,
  Map,
  Polyline,
  Placemark,
  GeoObject,
  Clusterer,
} from "react-yandex-maps";
import { AkmolaCoords } from "../../constants";

const RoadRepairMap = (props) => {
  const getPointData = (element) => {
    return {
      balloonContentBody: "<strong> " + element.name + "</strong>",
      clusterCaption: "Камера <strong>" + element.id + "</strong>",
    };
  };

  return (
    <>
      <YMaps>
        <Map
          state={{
            center: [53.2833, 69.4],
            zoom: 10,
            behaviors: ["default", "scrollZoom"],
            controls: [
              "searchControl",
              "fullscreenControl",
              "zoomControl",
              "rulerControl",
            ],
          }}
          width="100%"
          height="600px"
          // height="100%"
        >
          <Polyline
            geometry={{
              coordinates: AkmolaCoords.map((e) => [e[1], e[0]]),
            }}
            options={{
              strokeColor: "#000000",
              strokeWidth: 4,
              strokeOpacity: 1,
            }}
          />
          <Clusterer
            options={{
              preset: "islands#blueClusterIcons",
              groupByCoordinates: false,
              clusterDisableClickZoom: true,
              clusterHideIconOnBalloonOpen: false,
              geoObjectHideIconOnBalloonOpen: false,
            }}
          >
            {props.cameraMaps.map((element, idx) => (
              <Placemark
                key={idx}
                geometry={{
                  type: "Point",
                  coordinates: [element.latitude, element.longitude],
                }}
                options={{
                  preset: "islands#circleIcon",
                  iconColor: "#1e98ff",
                }}
                properties={getPointData(element)}
              />
            ))}
          </Clusterer>
        </Map>
      </YMaps>
    </>
  );
};

export default RoadRepairMap;
